module.exports = {
  HOME_PAGE: 'landingPages/HomePage',
  PROPERTY_RESEARCH_LANDING_PAGE: 'landingPages/PropertyResearchLandingPage',
  PROPERTY_RESEARCH_SUB_LANDING_PAGE:
    'landingPages/PropertyResearchSubLandingPage',
  PROPERTY_RESEARCH_COMBO_LANDING_PAGE:
    'landingPages/PropertyResearchComboLandingPage',
  LOCATION_INSIGHT_LANDING_PAGE: 'landingPages/LocationInsightLandingPage',
  LOCATION_INSIGHT_SUB_LANDING_PAGE:
    'landingPages/LocationInsightSubLandingPage',
  NEWS_LANDING_PAGE: 'landingPages/NewsLandingPage',
  NEWS_SUB_LANDING_PAGE: 'landingPages/NewsSubLandingPage',
  GUIDES_LANDING_PAGE: 'landingPages/GuidesLandingPage',
  GUIDES_SUB_LANDING_PAGE: 'landingPages/GuidesSubLandingPage',
  DECOR_LANDING_PAGE: 'landingPages/DecorLandingPage',
  DECOR_SUB_LANDING_PAGE: 'landingPages/DecorSubLandingPage',
  AUTHOR_PAGER: 'AuthorPage',
  SEARCH_RESULT_PAGE: 'searchResultPage/SearchResultPage',
  CONTENT_PAGE: 'contentPage/ContentPage',
  PROJECT_PAGE: 'projectPage/ProjectPage',
  FOOTER_PAGE: 'footerPage/FooterPage',
  EXTRA_PAGE: 'extraPage/ExtraPage',
  PROFILE_PAGE: 'profilePage/ProfilePage',
  GDPR_POPUP_MESSAGE: 'GDPRPopupMessage',
  FEATURE_FLAGS_PAGE: 'featureFlagsPage/FeatureFlagsPage',
  PROPERTY_PAGE: 'propertyPage/PropertyPage',
};
